import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getHibernationSchedulesQueryKey } from 'hooks/queries/cluster-autoscaler/useGetHibernationSchedulesQuery';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

export const useDeleteHibernationScheduleMutation = () => {
  const { currentOrganization } = useOrganizations();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => {
      return apiClient.clusterAutoscaler.deleteHibernationSchedule({
        organizationId: currentOrganization!.id,
        id,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getHibernationSchedulesQueryKey(currentOrganization!.id),
      });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
